import { Chip, Tooltip } from "@mui/material";

type Props = {
	code: "M" | "R";
};

export const SourceCodeTag = ({ code }: Props) => {
	const config = {
		M: { label: "Mill", color: "#1976d2" },
		R: { label: "Rollshop", color: "#9c27b0" },
	};
	const { label, color } = config[code] || { label: code, color: "#757575" };

	return (
		<Tooltip title={label} arrow>
			<Chip
				label={label}
				size="small"
				sx={{
					backgroundColor: `${color}15`,
					color: color,
					fontWeight: 600,
					fontSize: "0.7rem",
					height: 22,
				}}
			/>
		</Tooltip>
	);
};
